<template>
  <div class="region-area">
    <el-form-item :label="$t('BUILDING/STREET')">
      <br />
      <v-select v-model="localAddressObj" label="address" :reduce="(item) => item" :options="localAddresses"
        :filterBy="customFilterBy"
        @search="searchLocalAddress">
        <template v-slot:no-options="{ search, searching }">
          <template v-if="searching">
            <div>
              <div class="not-found-text"> {{ $t("NOT_FOUND") }}: {{ search }}</div>
              <div class="not-found-text"> {{ $t("BUILDING_NOT_FOUND_CALL_DSI") }}</div>
            </div>

          </template>
          <div style="opacity: 0.5" v-else>{{
            $t("PLEASE_INPUT_KEYWORD")
          }}</div>
        </template>
      </v-select>
    </el-form-item>

    <div v-show="localAddressObj">

      <el-form-item :label="$t('FLOOR')">
        <span class="other-tips" v-show="floorType == 'OTHER'">{{
          $t("FLOOR_OTHER_HINT")
        }}</span>
        <div>
          <br v-show="floorType != 'OTHER'" />
          <el-input type="tel" :placeholder="$t('FLOOR_HINT')" v-model="localAddressFloor" class="input-select"
            :disabled="floorInputDisableFlag">
          </el-input>
          <el-select v-model="floorType" slot="append" class="type-selector" @change="selectFloorType">
            <el-option :label="$t('FLOOR_TYPE_F')" value="F"></el-option>
            <el-option :label="$t('FLOOR_TYPE_R/C')" value="R/C"></el-option>
            <el-option :label="$t('FLOOR_TYPE_OTHER')" value="OTHER"></el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item :label="$t('UNIT')">
        <span class="other-tips" v-show="unitType == 'OTHER'">{{
          $t("UNIT_OTHER_HINT")
        }}</span>
        <div>
          <br v-show="unitType != 'OTHER'" />
          <el-input :placeholder="$t('UNIT_HINT')" v-model="localAddressUnit" :disabled="unitInputDisableFlag"
            class="input-select">
          </el-input>
          <el-select v-model="unitType" slot="append" class="type-selector" @change="selectUnitType">
            <el-option :label="$t('UNIT_TYPE_UNIT')" value="UNIT"></el-option>
            <el-option :label="$t('UNIT_TYPE_ROOM')" value="ROOM"></el-option>
            <el-option :label="$t('UNIT_TYPE_STORE')" value="STORE"></el-option>
            <el-option :label="$t('UNIT_TYPE_OTHER')" value="OTHER"></el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item :label="$t('OTHER_PART')">
        <el-input style="width: 100%" :placeholder="$t('OTHER_PART_HINT')" v-model="localAddressOther"></el-input>
      </el-form-item>
    </div>
  </div>
</template>
<script>
import { getLocale } from "@/i18n.js";
import { getLocaledFloorAndUnitStr, getFloorValue, getUnitValue } from "./floor_and_unit.js";

import ChineseTool from 'chinese-s2t'


let allAddressList = [];
let cAddressFullList = [];
let pAddressFullList = [];
let eAddressFullList = [];


const macauPrefxMap = {
  en: {
    M: " MACAO",
    T: " TAIPA, MACAO",
    C: " COLOANE, MACAO",
  },
  pt: {
    M: " MACAU",
    T: " TAIPA, MACAU",
    C: " COLOANE, MACAU",
  },
  zh: {
    M: "澳門",
    T: "澳門氹仔",
    C: "澳門路環",
  },
};
const getLocaledMacauPrefix = (locale, region) => {
  return macauPrefxMap[locale][region];
};


const contactAddress = (seperator, firstPart, secondPart) => {
  if (firstPart == "" || firstPart == null) {
    return secondPart;
  }
  if (secondPart == "" || secondPart == null) {
    return firstPart;
  }
  return firstPart + seperator + secondPart;
};

const convertLocalAddres = (localAdress, seperator) => {
  if (localAdress == "" || localAdress == null) {
    return "";
  }
  const list = localAdress.split(" / ");
  const building = list.shift();
  if (list.length === 0) {
    return building;
  }
  return list.join("/") + seperator + building;
};

export default {

  data() {
    return {
      floorType: "F",
      unitType: "ROOM",
      floorInputDisableFlag: false,
      unitInputDisableFlag: false,
      localAddressOther: "",
      localAddressFloor: "",
      localAddressUnit: "",
      localAddressObj: null,
      localAddresses: [],
      search: "",
      offset: 0,
      limit: 20,
    }
  },

  props: ['showIncompleteInputParent', 'showWarningParent', 'showInvalidFieldParent'],

  computed: {

  },
  methods: {

    loadAddressData(data) {
      allAddressList = [];

      cAddressFullList = data.cAddress;
      pAddressFullList = data.pAddress;
      eAddressFullList = data.eAddress;

      cAddressFullList.forEach(x => x['buildingLang'] = "zh");
      eAddressFullList.forEach(x => x['buildingLang'] = "en");
      pAddressFullList.forEach(x => x['buildingLang'] = "pt");

      allAddressList = cAddressFullList
        .concat(pAddressFullList)
        .concat(eAddressFullList);

      allAddressList = allAddressList.sort((a, b) => a.address.localeCompare(b.address));

    },

    selectFloorType() {
      if (this.floorType == "F") {
        this.floorInputDisableFlag = false;
      } else {
        if (this.floorType == "OTHER") {
          this.unitType = "OTHER";
          this.localAddressFloor = "";
          this.selectUnitType();
        }

        this.floorInputDisableFlag = true;
      }
    },

    selectUnitType() {
      if (this.unitType != "OTHER") {
        this.unitInputDisableFlag = false;
      } else {
        this.localAddressUnit = "";
        this.unitInputDisableFlag = true;
      }
    },


    async loadLatestAddressData(data) {
      this.loading = true;
      cAddressFullList = data.cAddress;
      pAddressFullList = data.pAddress;
      eAddressFullList = data.eAddress;
      this.loadAddressData();
  
    },

    customFilterBy(option, label, search) {
      const search1Txt= search.toLocaleLowerCase()
      const search2Txt = ChineseTool.s2t(search1Txt)
      const labelTxt =(label || '').toLocaleLowerCase()

      return (labelTxt.indexOf(search1Txt) > -1) || (labelTxt.indexOf(search2Txt) > -1) 
    },

    searchLocalAddress(search) {
      const searchKey = search.toLowerCase().trim();
      const searchKey2 = ChineseTool.s2t(searchKey)
      if (searchKey !== "" && searchKey.length > 1) {
        const filtered = allAddressList.filter((x) =>
          (x.address.toLowerCase().includes(searchKey)) ||
          (x.address.toLowerCase().includes(searchKey2))
        );

        this.localAddresses = filtered;
      } else {
        this.localAddresses = [];
      }
    },

    getFloorAndUnitStr(locale) {
      const { localAddressFloor, localAddressUnit, floorType, unitType } = this;
      return getLocaledFloorAndUnitStr(locale, localAddressFloor, localAddressUnit, floorType, unitType)
    },


    getLocalAddressRemain(locale) {
      return this.getFloorAndUnitStr(locale) + this.localAddressOther;
    },


    getFullAddress() {
      const { localAddressObj } = this;

      const localAddress = localAddressObj ? localAddressObj.address : "";

      let locale;
      if (localAddressObj) {
        locale = localAddressObj.buildingLang || getLocale();
      } else {
        locale = getLocale();
      }

      const localAddressRemain = this.getLocalAddressRemain(locale);

      const seperator = locale == "pt" || locale == "en" ? "," : "";
      const localAddressStr = convertLocalAddres(localAddress, seperator);
      const address = contactAddress(
        seperator,
        localAddressStr,
        localAddressRemain
      );

      let country = "";
      if (localAddressObj) {
        country = getLocaledMacauPrefix(locale, localAddressObj.rg);
      }
      if (locale == "pt" || locale == "en") {
        return contactAddress(seperator, address, country).toUpperCase();
      } else {
        return contactAddress(seperator, country, address).toUpperCase();
      }
    },

    validForm() {
      this.localAddressUnit = this.localAddressUnit.trim();
      this.localAddressFloor = this.localAddressFloor.trim();

      const { localAddressObj, localAddressFloor, localAddressUnit, localAddressOther, floorType } = this;


      if (!localAddressObj) {
        this.showWarningParent(this.$t("ADDRESS_BUILDING_NOT_FOUND"));
        return false;
      }

      if (floorType == 'F' && (!localAddressFloor || localAddressFloor == '' )) {
        this.showInvalidFieldParent(this.$t("FLOOR"), this.$t("FLOOR_HINT"));
        return false;
      }

      if (localAddressUnit && localAddressUnit.match(/[^0-9a-zA-Z]/)) {
        this.showInvalidFieldParent(this.$t("UNIT"), this.$t("UNIT_HINT"));
        return false;
      }

      if (localAddressFloor && localAddressFloor.match(/[^0-9]/)) {
        this.showInvalidFieldParent(this.$t("FLOOR"), this.$t("FLOOR_HINT"));
        return false;
      }


      if (localAddressObj.buildingLang != 'zh' && localAddressOther != '') {
        const pattern = /[\u4E00-\u9FFF\u3400-\u4DFF]/; // Chinese Unicode range
        if (pattern.test(localAddressOther)) {
          this.showInvalidFieldParent(this.$t("OTHER_PART"));
          return false;
        }
      }

      if (localAddressUnit == "" && localAddressFloor == "" && localAddressOther == "") {
        this.showWarningParent(this.$t("input_incomplete"));
        return false;
      }

      return true;
    },

    getSubmitObject() {
      const { localAddressObj, localAddressFloor, localAddressUnit, localAddressOther, floorType, unitType } = this;
      return {
        region: localAddressObj.rg,
        country: null,
        address: localAddressObj.address,
        streetcode: localAddressObj.streetCode,
        buildingcode: localAddressObj.buildingCode,
        floor: getFloorValue(localAddressFloor, floorType),
        unit: getUnitValue(localAddressUnit, unitType),
        other: localAddressOther,
        fulladdress: this.getFullAddress(),
        blang: (localAddressObj.buildingLang || getLocale()),
      };
    }
  }
}
</script>

<style>
.input-label {
  font-size: 12px;
  margin-bottom: 2px;
}

.address-input {
  width: 100%;
}

.region-area {
  min-height: 300px;
}

.not-found-text{
  line-height: 1.5;
  text-align: left;
}

.vs__search::placeholder {
  font-style: normal !important;

}
</style>

